import { useState } from "react";
import { EyeOff } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Expander } from "@/components/Expander";
import { api, apiError } from "@/lib/api";

/** A super-admin's switches: which categories of the team the whole portal shows. */
export const CategoryToggles = ({ categories, onChanged }) => {
  const [busy, setBusy] = useState("");
  const off = categories.filter((c) => !c.visible);
  const flip = async (c, visible) => {
    if (!visible && !window.confirm(`Hide ${c.label} from People, the counts and the team reports for everyone on the portal?`)) return;
    setBusy(c.key);
    try {
      await api.put("/people/categories", { key: c.key, visible });
      toast.success(`${c.label} ${visible ? "shown" : "hidden"} for everyone.`);
      onChanged();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy("");
    }
  };
  return (
    <div className="mt-6">
      <Expander
        title="Categories on the portal"
        note={
          off.length
            ? `Hidden for everyone: ${off.map((c) => c.label).join(", ")}`
            : "Switch a category off to hide it from People, the counts and the team reports — for everyone."
        }
        testId="people-categories"
      >
        <div className="grid gap-px bg-border sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((c) => (
            <div
              key={c.key}
              className={`flex items-start justify-between gap-3 bg-card p-3 transition-colors duration-200 hover:bg-muted ${
                c.visible ? "" : "opacity-70"
              }`}
              data-testid={`category-${c.key}`}
            >
              <span className="min-w-0">
                <span className="flex items-center gap-1.5 text-sm font-bold">
                  {!c.visible && <EyeOff className="h-3.5 w-3.5 text-[hsl(var(--watch))]" />}
                  {c.label}
                </span>
                <span className="block text-[11px] text-muted-foreground">
                  {c.note} · <b className="font-data" data-testid={`category-count-${c.key}`}>{c.count}</b>
                </span>
              </span>
              <Switch
                checked={c.visible}
                disabled={busy === c.key}
                onCheckedChange={(v) => flip(c, v)}
                data-testid={`category-switch-${c.key}`}
              />
            </div>
          ))}
        </div>
      </Expander>
    </div>
  );
};
